exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AssetDetail .table2{font-family:sans-serif;width:auto}.AssetDetail .table2 thead th{vertical-align:middle}.AssetDetail .table2 th{font-size:12pt !important;font-weight:normal;color:white;border:1px solid;border-color:white;background-color:#c10000 !important;padding:0.35rem}.AssetDetail .table2 td{color:#333333;font-size:12pt !important;border:1px solid;border-color:white;background-color:#d3d3d3 !important;padding:0.45rem;vertical-align:top;word-break:break-word}\n", ""]);

// exports
